import React from 'react';
import ReactDOM from 'react-dom/client';
import { NextUIProvider } from '@nextui-org/react';
import { ThemeProvider as NextThemesProvider } from 'next-themes';
import App from './App.tsx';
import './index.css';
import { PostHogProvider } from 'posthog-js/react';
import './i18n/config';
import { ConfirmProvider } from 'common/src/components/ui';

const options = {
  api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
};

// Chrome parpadea al terminar las animaciones que framer-motion delega al
// compositor (Web Animations API): popovers de selects, autocompletes y menús.
// framer solo usa esa vía si `animate` es propiedad directa de Element.prototype;
// al moverla a HTMLElement/SVGElement anima por JavaScript y el parpadeo
// desaparece sin perder ninguna animación. `element.animate()` sigue funcionando.
const nativeAnimate = Element.prototype.animate;
if (nativeAnimate) {
  delete (Element.prototype as { animate?: unknown }).animate;
  for (const proto of [HTMLElement.prototype, SVGElement.prototype]) {
    Object.defineProperty(proto, 'animate', {
      value: nativeAnimate,
      configurable: true,
      writable: true,
    });
  }
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <PostHogProvider
      apiKey={import.meta.env.VITE_PUBLIC_POSTHOG_KEY}
      options={options}
    >
      <NextUIProvider locale='es-ES'>
        <NextThemesProvider
          attribute={['class', 'data-theme']}
          defaultTheme='light'
        >
          <ConfirmProvider>
            <App />
          </ConfirmProvider>
        </NextThemesProvider>
      </NextUIProvider>
    </PostHogProvider>
  </React.StrictMode>
);
